import './set-public-path';
import { refetchCurrentUser } from './shared-api-objects/currentUser';
import { refetchEntitlements } from './shared-api-objects/entitlements';
import { refetchPreferences } from './shared-api-objects/preferences';
import { refetchPortfolios } from './shared-api-objects/portfolios';
import { refetchConfig } from './shared-api-objects/config';
import { refetchResearchFacets } from './shared-api-objects/researchFacets';
import { activateActivityTracker } from './activityTracker';
import { activateRefreshAccessToken } from './refreshAccessToken';
import { refetchCountriesIndustriesFacets } from './shared-api-objects/countriesIndustriesFacets';

// We know that we'll need the entitlements & current user as soon as possible,
// so we begin fetching them immediately, then activate the activity tracker and refresh token
refetchConfig();
refetchCurrentUser();
refetchEntitlements();
refetchPreferences();
refetchPortfolios();
refetchResearchFacets();
refetchCountriesIndustriesFacets();
activateActivityTracker();
activateRefreshAccessToken();

// Anything exported from this file is importable by other in-browser modules.
export {
  axiosXhr,
  axiosXhrCancelable,
  isAxiosXhrCancel,
  authenticatedAxios,
} from './axiosXhr.js';
export { apolloClient, apolloBatchClient } from './apolloClient';
export { contentfulClient } from './contentfulClient.js';
export { appLogout, UNAUTHORIZED } from './services/logout';
export {
  getEntitlements,
  refetchEntitlements,
} from './shared-api-objects/entitlements';
export {
  getCurrentUser,
  refetchCurrentUser,
} from './shared-api-objects/currentUser';

// exporting fetching entityInfo
export { getEntityInfo } from './shared-api-objects/getEntityInfo';

export { getConfig, refetchConfig } from './shared-api-objects/config';
export {
  getPortfolios,
  refetchPortfolios,
  triggerPortfolioChangeEvent,
} from './shared-api-objects/portfolios';
export {
  getPreferences,
  refetchPreferences,
  savePreferences,
} from './shared-api-objects/preferences';
export {
  getResearchFacets,
  refetchResearchFacets,
} from './shared-api-objects/researchFacets';
export {
  getCountriesIndustriesFacets,
  refetchCountriesIndustriesFacets,
} from './shared-api-objects/countriesIndustriesFacets';
